import { COMPUTE_TASK_STATUS, COMPUTE_TASK_TYPES } from '@/constants';

type TransferChild = { taskType?: string | null } | null;
type TransferParent = {
  status?: string | null;
  attributes?: unknown;
  subtasks?: readonly TransferChild[] | null;
};

const startingStatuses = new Set<string>([
  COMPUTE_TASK_STATUS.PENDING,
  COMPUTE_TASK_STATUS.CREATING,
  COMPUTE_TASK_STATUS.RUNNING,
]);

const transferTypes = [
  { type: COMPUTE_TASK_TYPES.FTP_TRANSFER, label: 'FTP' },
  { type: COMPUTE_TASK_TYPES.BASESPACE_TRANSFER, label: 'BaseSpace' },
  { type: COMPUTE_TASK_TYPES.WASABI_TRANSFER, label: 'Wasabi' },
];

// The one list of transfer types; the Upload Manager lists these children.
export const TRANSFER_TASK_TYPES = transferTypes.map(({ type }) => type);

export function getStartingTransferPlaceholder(
  parents: readonly (TransferParent | null)[]
): string | null {
  const counts = new Map<string, number>();

  for (const parent of parents) {
    if (
      !parent ||
      !startingStatuses.has(parent.status || '') ||
      !parent.subtasks
    ) {
      continue;
    }

    const attributes = JSON.stringify(parent.attributes ?? null);
    const transfer = transferTypes.find(({ type }) =>
      attributes.includes(type)
    );
    if (!transfer) continue;

    // The parent's nested subtasks are independent of the visible list page.
    if (parent.subtasks?.some((child) => child?.taskType === transfer.type)) {
      continue;
    }
    counts.set(transfer.type, (counts.get(transfer.type) ?? 0) + 1);
  }

  const parts = transferTypes
    .filter(({ type }) => counts.has(type))
    .map(({ type, label }) => `${counts.get(type)} ${label}`);
  if (!parts.length) return null;

  const total = [...counts.values()].reduce((sum, count) => sum + count, 0);
  const names =
    parts.length > 1
      ? `${parts.slice(0, -1).join(', ')} and ${parts[parts.length - 1]}`
      : parts[0];
  return `Starting ${names} transfer${total > 1 ? 's' : ''}`;
}
